export default __webpack_public_path__ + "static/payment-gateway-codebuilder-a22cdf7e54323bf12d9c108d90e0d5b5.png";